import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { mainAxios } from "../../app/api";
import service from "../../config.json";
import { errorToast, successToast } from "../../helpers/toaster";
const { getVisa, applyVisa, myVisaBookings, addVisaDocument, updateVisa } =
  service;
const { Authorization } = JSON.parse(sessionStorage.getItem("userData")) || {};

const initialState = {
  visaTypes: [],
  loading: false,
  visaCount: 1,
  visaBookings: [],
  applyStatus: "",
  documentStatus: false,
  updateVisaStatus: false,
};

export const fetchVisaAsync = createAsyncThunk(
  "visa/fetchVisaAsync",
  async (Authorization) => {
    try {
      const res = await mainAxios.get(getVisa, {
        headers: {
          Authorization,
        },
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
);
// fetchMyVisaBookings
export const fetchMyVisaBookings = createAsyncThunk(
  "visa/fetchMyVisaBookings",
  async (Authorization) => {
    try {
      const res = await mainAxios.get(myVisaBookings, {
        headers: {
          Authorization,
        },
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
);

// applyVisaAsync
export const applyVisaAsync = createAsyncThunk(
  "visa/applyVisaAsync",
  async (state) => {
    const { travellers, total, selectedVisaType, User } = state;
    const { Authorization } = User;
    const { Email, CountryCode, MobileNo, TravelDate } = state.state;

    let visitors = [];
    travellers.forEach((ele) => {
      let Obj = {
        title: ele.Title,
        name: ele.FirstName,
        surname: ele.LastName,
        age: parseInt(ele.Age),
        gender: ele.Gender,
      };
      visitors.push(Obj);
    });

    try {
      const res = await mainAxios.post(
        applyVisa,
        {
          visa_masters_id: parseInt(selectedVisaType),
          paid_amount: total,
          visitors,
          contact_number: MobileNo,
          email: Email,
          country_code: CountryCode,
          travel_date: TravelDate,
        },
        {
          headers: {
            Authorization,
          },
        }
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
);

// updateVisaAsync
export const updateVisaAsync = createAsyncThunk(
  "visa/updateVisaAsync",
  async (val) => {
    const { Authorization, travellers, total, selectedVisaType, state, Id } =
      val;
    // const { travellers, total, selectedVisaType, User } = state;
    // const { Authorization } = User;
    const { Email, CountryCode, MobileNo, TravelDate } = state;

    let visitors = [];
    travellers.forEach((ele) => {
      let Obj = {
        title: ele.Title,
        name: ele.FirstName,
        surname: ele.LastName,
        age: parseInt(ele.Age),
        gender: ele.Gender,
      };
      visitors.push(Obj);
    });
    try {
      const res = await mainAxios.post(
        updateVisa,
        {
          visaId: Id,
          visa_masters_id: parseInt(selectedVisaType),
          paid_amount: total,
          visitors,
          contact_number: MobileNo,
          email: Email,
          country_code: CountryCode,
          travel_date: TravelDate,
        },
        {
          headers: {
            Authorization,
          },
        }
      );
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
);

export const addVisaDocumentAsync = createAsyncThunk(
  "visa/addVisaDocumentAsync",
  async (state) => {
    const { Authorization } = state;
    const { photograph, passportFront, passportBack } = state.state;

    const { id } = state.state;

    let test = {
      passport_front: passportFront,
      passport_back: passportBack,
      photograph: photograph,
    };

    let formData = new FormData();

    Object.keys(test).map((key) => {
      if (test[key] !== undefined) {
        formData.append(key, test[key], `${test[key]}.jpg`);
      }
    });

    formData.append("visa_booking_detail_id", id);
    try {
      const res = await mainAxios.post(addVisaDocument, formData, {
        headers: {
          Authorization,
        },
      });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
);

export const visaSlice = createSlice({
  name: "visa",
  initialState,
  reducers: {
    appendVisa: (state) => {
      state.visaCount += 1;
    },
    resetVisaStatus: (state) => {
      state.applyStatus = "";
    },
    resetUploadStatus: (state) => {
      state.documentStatus = false;
    },
    resetVisaBookings: (state) => {
      state.visaBookings = [];
    },
    resetUpdateVisaStatus: (state) => {
      state.updateVisaStatus = false;
    },
  },
  extraReducers: {
    [fetchVisaAsync.pending]: (state) => {
      return { ...state, loading: true };
    },
    [fetchVisaAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        return { ...state, visaTypes: payload.data, loading: false };
      } else {
        errorToast(payload?.message);
        return { ...state, loading: false };
      }
    },
    [applyVisaAsync.pending]: (state) => {
      return { ...state, loading: true, applyStatus: false };
    },
    [applyVisaAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        return { ...state, loading: false, applyStatus: payload.data };
      } else {
        errorToast(payload?.message);
        return { ...state, loading: false };
      }
    },
    [fetchMyVisaBookings.pending]: (state) => {
      return { ...state, loading: true };
    },
    [fetchMyVisaBookings.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        return { ...state, loading: false, visaBookings: payload.data };
      } else {
        errorToast(payload?.message);
        return { ...state, loading: false };
      }
    },
    [addVisaDocumentAsync.pending]: (state) => {
      return { ...state, loading: true };
    },
    [addVisaDocumentAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        return { ...state, loading: false, documentStatus: payload.data };
      } else {
        errorToast(payload?.message);
        return { ...state, loading: false };
      }
    },
    [updateVisaAsync.pending]: (state) => {
      return { ...state, loading: true };
    },
    [updateVisaAsync.fulfilled]: (state, { payload }) => {
      if (payload?.success) {
        successToast("Documents Updated Successfully!");
        return { ...state, loading: false, updateVisaStatus: true };
      } else {
        errorToast(payload?.message);
        return { ...state, loading: false, updateVisaStatus: false };
      }
    },
  },
});

export const getVisaTypes = (state) => {
  return state.visa.visaTypes;
};

export const getVisaCounts = (state) => {
  return state.visa.visaCount;
};

export const getApplyStatus = (state) => {
  return state.visa.applyStatus;
};

export const getVisaBookings = (state) => {
  return state.visa.visaBookings;
};

// Action creators are generated for each case reducer function
export const {
  appendVisa,
  resetVisaStatus,
  resetUploadStatus,
  resetVisaBookings,
  resetUpdateVisaStatus,
} = visaSlice.actions;

export default visaSlice.reducer;
